import React, { useEffect, useState } from "react";
import "./CreateTask.css";
import axios from "axios";
import DonutChart from "../DonutChart/DonutChart";
function CreateTask({
  data,
  setAllData,
  showId,
  asignTo,
  setAsignTo,
  chartData,
}) {
  const [createchange, setCreatechange] = useState(false);
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [category, setCatogory] = useState("");
  const [description, setDescription] = useState("");
  const [employee, setEmployee] = useState("");
  useEffect(() => {
    if (showId) {
      const emp = data.find((emp) => {
        return emp.id === showId;
      });
      setEmployee(emp);
    }
  }, [showId, createchange,data]);
  const createhandler = (e) => {
    e.preventDefault();
    data.map((user) => {
      if (user.id === asignTo) {
        const arr = [
          ...user.tasks,
          {
            active: false,
            newTask: true,
            completed: false,
            date: date,
            description: description,
            failed: false,
            category: category,
            title: title,
          },
        ];
        let updatedUser = data.toSpliced(user.id - 1, 1, {
          id: user.id,
          name: user.name,
          email: user.email,
          password: user.password,
          role: "employee",
          taskCounts: {
            active: user.taskCounts.active,
            newTask: user.taskCounts.newTask + 1,
            completed: user.taskCounts.completed,
            failed: user.taskCounts.failed,
          },
          tasks: arr,
        });
        setAllData(updatedUser);
        setCreatechange(!createchange);
        axios.put(
          `https://673cbd3d96b8dcd5f3fb6024.mockapi.io/emts2/${asignTo}`,
          {
            taskCounts: {
              active: user.taskCounts.active,
              newTask: user.taskCounts.newTask + 1,
              completed: user.taskCounts.completed,
              failed: user.taskCounts.failed,
            },
            tasks: arr,
          }
        );
      }
      return true;
    });
  };
  return (
    <div className="create-task">
      <div>
        <div className="row py-3">
          <div className="col-lg-9 mb-3">
          <div className="emp-detail-wrapper">
            <div className="row empdetails">
              <div className="col-6">
                <p>
                  <span>Employee ID:</span> {employee.id}
                </p>
              </div>
              <div className="col-6">
                <h4>
                  <span>Name:</span> {employee.name}
                </h4>
              </div>
              <div className="col-12">
                <p>
                  <span>Email:</span> {employee.email}
                </p>
              </div>
            </div>
            <div className="row emptask">
              <div className="col-12">
                <div>
                  <div className="d-flex justify-content-between task_title">
                    <p className="col-6">Title</p>
                    <p className="d-none d-sm-block col-4">Due date</p>
                    <p className="col-2">Status</p>
                  </div>
                  {employee &&
                    employee.tasks.map((task, index) => {
                      return (
                        <div
                          className="d-flex justify-content-between tasks"
                          key={index}
                        >
                          <p className="col-6">{task.title}</p>
                          <p className="d-none d-sm-block col-4">{task.date}</p>
                          <p className="col-2">
                            {task.newTask ? (
                              <span className="status_new">Newtask</span>
                            ) : task.active ? (
                              <span className="status_accepted">Accepted</span>
                            ) : task.completed ? (
                              <span className="status_completed">
                                Completed
                              </span>
                            ) : (
                              <span className="status_failed">Failed</span>
                            )}
                          </p>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
          </div>
          <div className="col-sm-8 mx-auto col-lg-3 mb-3">
            <div className="form-left-content">
              <h5 className="prof">Profile</h5>
              <p>Task PieChart</p>
              {employee && <DonutChart data={chartData} />}
            </div>
          </div>
        </div>

        <form onSubmit={createhandler} className="task_form">
          <div className="row justify-content-between mb-0">
            <div className="col-lg-6 mb-0 px-2">
              <div className="mb-2">
                <label className="label">Task Title</label> <br />
                <input
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  type="text"
                  placeholder="Enter Title Here"
                  className="inp"
                />
              </div>
            </div>
            <div className="col-lg-6 mb-0 px-2">
              <div className="mb-2">
                <label className="label">Catogory</label> <br />
                <input
                  value={category}
                  onChange={(e) => setCatogory(e.target.value)}
                  placeholder="Enter catogory here"
                  className="inp"
                />
              </div>
            </div>
            <div className="col-lg-6 mb-0 px-2">
              <div className="mb-2">
                <label className="label">Date</label> <br />
                <input
                  value="2024-11-24"
                  onChange={(e) => setDate(e.target.value)}
                  type="date"
                  placeholder="29/10/2024"
                  className="inp"
                />
              </div>
            </div>
            <div className="col-lg-6 mb-0 px-2">
              <div className="mb-2">
                <label className="label">Asign To</label> <br />
                <input
                  value={asignTo}
                  onChange={(e) => setAsignTo(e.target.value)}
                  type="text"
                  placeholder="Enter Employee Id"
                  className="inp"
                />
              </div>
            </div>
          </div>
          <div className="row justify-content-between mb-0">
            <div className="col-12 px-2">
              <label className="label">Discription</label>
              <textarea
                value={description}
                className="dec"
                placeholder="Enter description"
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
            <div className="col-12 px-2">
              <button className="task_btn" type="submit">
                Create Task
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateTask;
